import { GoogleDeviceStatus } from '@cdw-ae/common-data';
import type {
  FilterBarField,
  SelectedFilterField,
} from '@cdw-ae/filter-bar-interfaces';
import { FilterBarParamStrategy } from '@cdw-ae/url-params';
import { StateAnalysisReportFilterSettings } from '../../../../../common/services/route-config/configs/filter-bar-config.config';

/** Payload mirroring onActionClick(cardId, clickedValue?, targetFilterBar?). */
export interface DashboardCardAction {
  cardId: string;
  clickedValue?: string;
  targetFilterBar?: string;
}

// verbatim from dashboard.component.ts:103-110
export const DASHBOARD_FILTER_FIELD_MASK: string[] = [
  'vendorProperties.google.orgUnitPath',
  'status',
  'model',
  'batteryHealth',
  'diskUsed',
  'osVersion',
];

export const DASHBOARD_FILTER_BAR_SETTINGS: FilterBarField[] =
  StateAnalysisReportFilterSettings.filter(f => DASHBOARD_FILTER_FIELD_MASK.includes(f.name));

export function buildDefaultActiveDeviceFilter(
  strategy: FilterBarParamStrategy,   // @cdw-ae/url-params, providedIn: 'root'
  settings: FilterBarField[],
): SelectedFilterField[] {
  return strategy.convertToInput(
    [{ field: 'status', operator: 'equals' as const, value: GoogleDeviceStatus.ACTIVE }],
    settings,
  );
}
